// Clientes.js
import React from 'react';

const Clientes = () => {
  return <div>Clientes Page</div>;
};

export default Clientes;